var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header",class:{
    'header--init': _vm.init && _vm.$route.name === 'home',
    'header--left': this.$route.name !== 'home',
  }},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/img/logo.svg"),"alt":"Regnum"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }